export const MILLISECONDS_UNTIL_POST_IS_OLD = 86_400_000; // 24h
export const MILLISECONDS_UNTIL_POST_VIEW_REMOVED = 8_640_000_000; // 100d
